module.exports = __webpack_public_path__ + "img/skinxs-logo.ff7ef26d.svg";